<template>
  <v-layout column class="info-width">
    <!-- INFO ALARMS -->
    <v-flex d-inline-flex align-center class="general-info-container" pa-3 mb-1>
      <v-flex style="max-width: 250px; min-width: 250px;">
        <h2>Vehículos instalados sin eventos +3h</h2>
      </v-flex>
      <!-- v-if="!loadingUnreportedEventsAlarms" -->
      <v-flex
        style="max-width: 190px; min-width: 190px;"
      >
        <h3 class="pl-2">
          <span class="body-2">Total Alarmas:</span>
          {{ vehicleWithoutEvents3hAlarms.length }}
        </h3>
      </v-flex>
    </v-flex>
    <!-- HEADER -->
    <v-flex d-flex px-4 py-1 mb-1 class="header-container">
      <v-flex class="cell-width-0 text-xs-left">Quien</v-flex>
      <v-flex class="cell-width-1 text-xs-center">Fecha y hora de instalación</v-flex>
      <v-flex class="cell-width-2 text-xs-center">Tiempo desde la instalación<span class="caption">(horas)</span></v-flex>
    </v-flex>
    <!-- LOADING -->
    <v-flex v-if="loadingVehicleWithoutEvents3hAlarms" pa-5>
      <v-progress-circular indeterminate color="white"></v-progress-circular>
      Cargando datos...
    </v-flex>
    <!-- CONTENT -->
    <v-flex v-else>
      <!-- ALARM DATA -->
      <v-flex v-if="vehicleWithoutEvents3hAlarms.length > 0">
        <v-flex
          v-for="(alarm, index) in vehicleWithoutEvents3hAlarms"
          :key="index"
          mb-1
        >
          <v-card flat>
            <v-flex
              class="info-width"
              d-inline-flex
              align-center
              pa-1
            >
              <!-- WHO -->
              <v-flex d-flex class="cell-width-0 text-xs-left" pl-4>
                <v-flex xs6>
                  <router-link :to="`/vehicles/${vehicleId(alarm.device)}`">
                    <v-flex>
                      <v-flex class="small-text">Código/Sigla</v-flex>
                      <v-flex><b>{{ vehicleCode(alarm.device) }}</b></v-flex>
                    </v-flex>
                    <v-flex pt-1>
                      <v-flex class="small-text">Placa</v-flex>
                      <v-flex><b>{{ vehicleLicensePlate(alarm.device) }}</b></v-flex>
                    </v-flex>
                  </router-link>
                </v-flex>
                <v-flex xs6>
                  <router-link :to="`/vehicles/${vehicleId(alarm.device)}`">
                    <v-flex>
                      <v-flex class="small-text">Dispositivo</v-flex>
                      <v-flex><b>{{ alarm.device }}</b></v-flex>
                    </v-flex>
                    <v-flex pt-1>
                      <v-flex class="small-text">Agencia</v-flex>
                      <v-flex><b>{{ getAgencyId(alarm.device) | agencyName }}</b></v-flex>
                    </v-flex>
                  </router-link>
                </v-flex>
              </v-flex>
              <!-- INSTALLATION DATE & TIME -->
              <v-flex class="cell-width-1 text-xs-center">
                {{ alarm.activationTimestamp | filterFullDate }}
              </v-flex>
              <!-- AMOUNT OF TIME FROM INSTALLATION -->
              <v-flex class="cell-width-2 text-xs-center">
                {{ duration(alarm) }}
              </v-flex>
            </v-flex>
          </v-card>
        </v-flex>
      </v-flex>
      <!-- MESSAGE -->
      <v-flex v-else px-3 py-3>
        <h2>En éste momento no hay alarmas por vehículos instalados hace más de 3 horas sin eventos.</h2>
        <p>A medida que se generen nuevas alarmas, éstas se cargaran automáticamente.</p>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'vehicles-without-events-3h-alerts',
  data() {
    return {
      intervalVehicleWithoutEvents3hAlarmsInstance: null,
      intervalVehicleWithoutEvents3hAlarmsValue: 20000
    }
  },
  computed: {
    ...mapGetters([
      'loadingVehicleWithoutEvents3hAlarms',
      'vehicleWithoutEvents3hAlarms',
      'vehicleId',
      'vehicleCode',
      'vehicleLicensePlate',
      'getAgencyId'
    ])
  },
  methods: {
    ...mapActions([
      'setLoadingVehicleWithoutEvents3hAlarms',
      'fetchVehicleWithoutEvents3hAlarms',
      'clearVehicleWithoutEvents3hAlarms'
    ]),
    duration(alarm) {
      let result = `${(alarm.duration / 3600).toFixed(2)} hrs`
      return result
    },
    intervalForVehicleWithoutEvents3hAlarms() {
      this.intervalVehicleWithoutEvents3hAlarmsInstance = setInterval(() => {
        this.fetchVehicleWithoutEvents3hAlarms()
      }, this.intervalVehicleWithoutEvents3hAlarmsValue)
      // console.log('intervalForMovementAlarms', this.intervalMovementAlarmsInstance)
    }
  },
  mounted() {
    this.setLoadingVehicleWithoutEvents3hAlarms(true)
    this.fetchVehicleWithoutEvents3hAlarms()
    this.intervalForVehicleWithoutEvents3hAlarms()
  },
  beforeDestroy() {
    clearInterval(this.intervalVehicleWithoutEvents3hAlarmsInstance)
    this.clearVehicleWithoutEvents3hAlarms()
  }
}
</script>

<style lang="stylus" scoped>
a
  text-decoration none
  color white
  font-size 16px

a:hover
  opacity 0.7

.info-width
  min-width 960px
  max-width 1024px

.general-info-container
  height 70px
  border-radius 3px
  background-color #424242

.header-container
  min-width 960px
  max-width 1024px
  height 35px
  border-radius 3px
  background-color #424242
  font-size 16px
  font-weight 500

.cell-width-0
  min-width 340px
  max-width 340px

.cell-width-1
  min-width 300px
  max-width 300px

.cell-width-2
  min-width 260px
  max-width 260px

.small-text
  font-size 8px
</style>


// WEBPACK FOOTER //
// src/components/VehiclesWithoutEvents3hAlerts.vue